import { generalConst } from "../../../module/globalInterface";

export const ATTACHMENT_TABS_IDENTIFIER = "attachmentTabs";
export const ATTACHMENT_LIST_IDENTIFIER = "attachmentList";
export const CALL_STATE_IDENTIFIER = "callState";

export const MANUALS_ROUTES: generalConst = {
  BASE: "/manuals-reference",
};

export interface IAttachmentPanelTab {
  id: string;
  name: string;
  description?: string;
}

export interface IMockAttachmentTable {
  id: string;
  idRequest: string;
  application: string;
  beneficiary: string;
  applicant: string;
}
